import { Config } from "./config"
import { getStore } from "./redux"
import { getAuthUserId } from "../components/auth/selectors"

export const GA_TRACKING_ID = Config.googleAnalyticsTrackingId

export const AnalyticsEventsEnum = {
    KBLinkClicked: "knowledge_base_link_clicked",
    ImageUploadError: "image_upload_error",
    ItemDetailGroupSorted: "item_detail_group_sorted",
    BulkDelete: "bulk_delete",
    DuplicateItem: "duplicate_item",
    GoogleReviewSuggestionsGenerated: "google_review_suggestions_generated",
    GoogleReviewSuggestionSent: "google_review_suggestion_sent",
    GoogleReviewSuggestionDismissed: "google_review_suggestion_dismissed",
    SidebarCollapsed: "sidebar_collapsed",
    SidebarExpanded: "sidebar_expanded",
}

export type AnalyticsEventsType = (typeof AnalyticsEventsEnum)[keyof typeof AnalyticsEventsEnum]
// https://developers.google.com/analytics/devguides/collection/gtagjs/events

export const sendEvent = (event: AnalyticsEventsType, params: Record<string, any> = {}): void => {
    // Guarded like gaPageView below: callers are no longer only browser click handlers.
    if (!GA_TRACKING_ID || typeof window === "undefined" || !window.gtag) {
        return
    }

    window.gtag("event", event, {
        ...params,
    })
}
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages

export const gaPageView = (url: string): void => {
    if (!GA_TRACKING_ID) {
        return
    }

    if (window && window.gtag) {
        const state = getStore()?.getState()

        window.gtag("config", GA_TRACKING_ID, {
            page_path: url,
            user_id: state ? getAuthUserId(state) : null,
        })
    }
}
